module.exports = __webpack_public_path__ + "img/hc_pro_one_2.58fff356.jpg";